export default {"src":"/_next/static/media/PlayLight.80b33fd5.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};